import BusRatesTable from './BusRatesTable';
// import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Thanetogoacab() {



const cardData = {
  keyword: " Thane to Goa Cabs",

headingDescription: "Velocity Cab provides reliable and comfortable Thane to Goa cab services, ensuring a smooth and hassle-free journey for family vacations, business trips, group travel, and leisure getaways. Our professional drivers, well-maintained vehicles, and punctual pickups make long-distance travel from Thane to Goa convenient and stress-free. The journey covers approximately 550 to 600 km and offers scenic views of highways, hills, and coastal landscapes. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Thane to Goa cab travel.",

topPlaces: [
  {
    title: "Baga Beach",
    description: "Baga Beach is one of Goa’s most popular beaches known for its vibrant nightlife, water sports, and beachside shacks. Travelers arriving from Thane by cab can relax on the sandy shores, enjoy activities like parasailing and jet skiing, and explore nearby cafes and clubs. The lively atmosphere makes it a perfect destination for both relaxation and entertainment."
  },
  {
    title: "Calangute Beach",
    description: "Calangute Beach, often called the ‘Queen of Beaches,’ is famous for its wide shoreline and bustling environment. Visitors traveling from Thane can enjoy sunbathing, shopping at nearby markets, and trying delicious Goan cuisine. It is one of the best places for families and groups to spend quality time by the sea."
  },
  {
    title: "Anjuna Beach",
    description: "Anjuna Beach is well known for its scenic beauty, rocky coastline, and vibrant flea markets. Travelers coming from Thane can explore its unique vibe, shop for souvenirs, and enjoy beach parties and music events. It is especially popular among young travelers and backpackers."
  },
  {
    title: "Dudhsagar Waterfalls",
    description: "Dudhsagar Waterfalls is one of India’s tallest waterfalls, located on the Goa-Karnataka border. Visitors traveling by cab from Thane can plan a trip to this breathtaking natural attraction, surrounded by lush greenery and forests. The waterfall looks spectacular during the monsoon season and is ideal for nature lovers and photographers."
  },
  {
    title: "Fort Aguada",
    description: "Fort Aguada is a historic Portuguese fort offering panoramic views of the Arabian Sea. Travelers from Thane can explore its lighthouse, strong fort walls, and scenic surroundings. It is a great place for sightseeing, photography, and learning about Goa’s colonial history."
  },
  {
    title: "Basilica of Bom Jesus",
    description: "The Basilica of Bom Jesus is a UNESCO World Heritage Site famous for housing the remains of St. Francis Xavier. Travelers arriving from Thane can admire its baroque architecture and peaceful interiors. It is one of the most important religious and historical landmarks in Goa."
  },
  {
    title: "Chapora Fort",
    description: "Chapora Fort is known for its stunning views of Vagator Beach and the Arabian Sea. Visitors traveling from Thane can hike up to the fort and enjoy breathtaking sunsets and panoramic scenery. It is also famous as a filming location for Bollywood movies."
  },
  {
    title: "Vagator Beach",
    description: "Vagator Beach is a beautiful and less crowded beach known for its red cliffs and scenic beauty. Travelers coming from Thane can enjoy peaceful surroundings, stunning sunsets, and nearby cafes. It is perfect for those looking for a calm and relaxing beach experience."
  },
  {
    title: "Colva Beach",
    description: "Colva Beach is one of the most visited beaches in South Goa, known for its white sand and calm waters. Visitors traveling by cab from Thane can relax, enjoy water sports, and explore nearby restaurants and local markets. It is ideal for families and couples."
  },
  {
    title: "Palolem Beach",
    description: "Palolem Beach is a serene and picturesque beach in South Goa known for its crescent-shaped shoreline and peaceful vibe. Travelers from Thane can unwind here, enjoy kayaking, dolphin spotting, and beachside dining. It is perfect for those seeking relaxation away from crowded areas."
  }
],



services: [
{
name: "Thane to Goa Cab Service",
description: "Thane to Goa cab service offers a comfortable and scenic long-distance journey to one of India’s most loved beach destinations. This service is ideal for families, friends, couples, and corporate travelers planning a relaxing road trip from Thane to Goa. The route passes through beautiful highways, lush greenery, and coastal landscapes, making the journey enjoyable and memorable. Professional drivers experienced in long-distance travel ensure safe driving and timely arrival. Customers can choose from sedan, SUV, and luxury vehicles based on their group size and comfort preference. Flexible pickup options from Thane West, Thane East, and nearby areas add convenience. With transparent pricing, easy booking, and 24x7 availability, this cab service ensures a hassle-free and enjoyable Goa travel experience."
},
{
name: "Thane to Goa Taxi",
description: "Thane to Goa taxi service provides reliable and comfortable transportation for long-distance travel with well-maintained vehicles and experienced drivers. This service is perfect for travelers who prefer a private journey with flexible travel schedules. Door-to-door pickup and drop ensure convenience and comfort. Multiple vehicle options including sedan and SUV are available for different budgets. Regular stops during the journey make travel comfortable. It ensures a smooth and stress-free trip."
},
{
name: "One Way Cab Thane to Goa",
description: "One way cab Thane to Goa is a cost-effective option for travelers who need a single-side drop without return charges. This service is ideal for those planning to stay in Goa or continue their journey further. Customers benefit from competitive pricing, flexible pickup timing, and comfortable vehicles. Professional drivers ensure safe and timely travel on highways. Sedan and SUV options are available based on travel needs. Easy online booking and instant confirmation make it highly convenient."
},
{
name: "Thane to Goa Cab Booking",
description: "Thane to Goa cab booking allows customers to reserve their cab quickly with instant confirmation and flexible scheduling. Travelers can choose vehicle type, pickup location, and travel date based on their convenience. Transparent pricing ensures no hidden charges during the journey. Online booking platforms provide a hassle-free experience with secure payment options. Dedicated support is available for assistance before and during travel. It is the easiest way to plan your Goa trip."
},
{
name: "Thane to Goa Taxi Fare",
description: "Thane to Goa taxi fare is designed to be transparent and competitive, helping travelers plan their budget effectively. Pricing varies based on vehicle type, distance, and trip duration. Customers receive clear cost breakdowns including tolls and driver allowance where applicable. Affordable options are available for sedan, SUV, and premium vehicles. No hidden charges ensure trust and reliability. It offers excellent value for long-distance travel."
},
{
name: "Thane to Goa Outstation Cab",
description: "Thane to Goa outstation cab service provides long-distance travel solutions with comfort and safety. This service is ideal for tourists and business travelers seeking a smooth intercity journey. Vehicles are well-maintained for performance on highways and ghat roads. Flexible pickup options and travel schedules add convenience. Travelers can choose between one way and round trip packages. It ensures a hassle-free and enjoyable journey."
},
{
name: "Cheap Cab Thane to Goa",
description: "Cheap cab Thane to Goa offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers who want reliable transportation at affordable rates. Economical sedan options are available for lower fares. Transparent pricing and no hidden charges make this service popular among travelers. Professional drivers ensure safe and smooth travel. It is a perfect choice for budget trips."
},
{
name: "Thane to Goa SUV Taxi",
description: "Thane to Goa SUV taxi is ideal for group travel and those seeking extra space and comfort during long journeys. SUVs provide spacious seating and better performance on highways and ghat sections. This option is suitable for families, friends, and corporate groups. Drivers are experienced in long-distance routes ensuring safety. It offers a premium and comfortable travel experience. Perfect for extended road trips."
},
{
name: "Thane to Goa Sedan Cab",
description: "Thane to Goa sedan cab is perfect for small families and couples looking for an affordable and comfortable ride. Sedans offer smooth travel, good mileage, and comfortable seating for long-distance journeys. This option is ideal for budget-friendly travel without compromising on convenience. Professional drivers ensure safe driving throughout the route. Easy booking and flexible timing enhance the travel experience. It is one of the most preferred options."
},
{
name: "Thane to Goa Car Rental",
description: "Thane to Goa car rental service provides flexible travel solutions with a wide range of vehicles to choose from. Customers can rent cars for one way or round trips based on their requirements. This service is suitable for personal, family, and corporate travel needs. Easy booking process and transparent pricing make it convenient for all users. Vehicles are clean, well-maintained, and driven by professional chauffeurs. It ensures a comfortable and customized journey."
},
{
name: "Private Cab Thane to Goa",
description: "Private cab Thane to Goa offers a personalized travel experience with exclusive vehicle usage for families and groups. Travelers can customize routes, stops, and travel schedules based on their preferences. This ensures a relaxed and stress-free journey. Professional drivers provide safe and reliable service throughout the trip. Comfortable seating and premium service enhance the experience. It is ideal for a private and luxurious road trip."
},
{
name: "AC Taxi Thane to Goa",
description: "AC taxi Thane to Goa ensures a comfortable journey in air-conditioned vehicles, especially during long-distance travel. This service provides a pleasant environment inside the vehicle regardless of weather conditions. Clean interiors and well-maintained AC systems enhance passenger comfort. Suitable for families, tourists, and business travelers. Flexible pickup options add convenience. It guarantees a relaxing travel experience."
},
{
name: "Book Thane to Goa Cab Online",
description: "Book Thane to Goa cab online for quick and hassle-free reservations with instant confirmation and flexible travel options. Customers can select vehicle type, travel date, and pickup location easily. Online booking platforms provide secure payment and transparent pricing. This service ensures availability of vehicles when needed. Dedicated support is available for assistance. It is the most convenient way to book a Goa cab."
},
{
name: "Thane to Goa Round Trip Cab",
description: "Thane to Goa round trip cab service is ideal for travelers planning a return journey after their Goa trip. This package includes pickup, drop, waiting time, and return travel with flexible schedules. Travelers can enjoy their vacation without worrying about return transport. Professional drivers ensure timely service and safe driving. Multiple vehicle options are available for families and groups. It offers convenience and cost efficiency."
},
{
name: "Best Cab Service Thane to Goa",
description: "Best cab service Thane to Goa ensures top-quality travel experience with well-maintained vehicles, professional drivers, and excellent customer support. This service focuses on safety, comfort, and punctuality for long-distance journeys. Customers can choose from a variety of vehicles based on their needs. Transparent pricing and easy booking enhance trust and convenience. It is the preferred choice for reliable Goa travel. It guarantees a premium travel experience."
}
],

tableData: [
["Thane to Goa Cab Service","Thane to Goa Taxi"],
["One Way Cab Thane to Goa","Thane to Goa Cab Booking"],
["Thane to Goa Taxi Fare","Thane to Goa Outstation Cab"],
["Cheap Cab Thane to Goa","Thane to Goa SUV Taxi"],
["Thane to Goa Sedan Cab","Thane to Goa Car Rental"],
["Private Cab Thane to Goa","AC Taxi Thane to Goa"],
["Book Thane to Goa Cab Online","Thane to Goa Round Trip Cab"],
["Best Cab Service Thane to Goa","Thane to Goa Cab Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Long Distance Travel",
    WhyChoosedescription: "Velocity Cabs offers reliable Thane to Goa cab services for a smooth and comfortable journey, ideal for family vacations, group trips, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance routes between Thane and Goa, ensuring safe driving, smooth navigation, and timely travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Thane to Goa cab bookings. Customers receive full fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Thane to Goa cab service operates 24/7. Whether you plan an early morning departure or overnight journey, Velocity Cabs ensures reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and relaxing long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and multi-day Goa travel packages."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, luxury SUVs, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Travel Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Thane to Goa cab bookings due to punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Thane to Goa cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Thane to Goa for one-way and round-trip travel." },
  { question: "How far is Goa from Thane?", answer: "The distance between Thane and Goa is approximately 580 to 620 km and the journey takes around 11 to 13 hours depending on the route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Thane to Goa cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, luxury SUVs, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Thane to Goa." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Thane to Goa cabs online or through phone booking." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, and offices across Thane." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and holiday seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Patil",
    feedback:
      "Thane to Goa cab service with Velocity Cab was an amazing experience. The vehicle was clean, comfortable, and perfect for a long scenic journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Joshi",
    feedback:
      "The Thane to Goa cab ride with Velocity Cab was very smooth and enjoyable. The driver was professional, and the trip was safe, punctual, and relaxing.",
    rating: 5
  }
];
























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const thaneGoaCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Thane to Goa Cabs | Velocity Cabs",
  "description": "Book a private cab from Thane to Goa for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Thane, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Thane to Goa Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Thane to Goa",
        "description": "Private cab from Thane to Goa for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Thane to Goa Cab",
        "description": "Comfortable round-trip cab service from Thane to Goa with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};





  return (
    <div>
      <Helmet>
  <title>Thane to Goa Cabs | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Thane to Goa for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(thaneGoaCabJSON)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/91.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Thanetogoacab;